import { useRouter } from 'next/router';
import { SHOW_COMMEMORATE } from 'src/constants';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import useResponsive from 'src/utils/devices';
import styled from 'styled-components';

function WidgetTags({ id, tags }) {
  const router = useRouter();
  const responsive = useResponsive();

  return (
    <WidgetWrapper id={id} style={{ filter: SHOW_COMMEMORATE === 'true' ? 'grayscale(0.7)' : '' }}>
      {tags?.map((item, index) => (
        <a
          key={index}
          className='tags-item'
          href={`/tags/${item}`}
          //! DATALAYER
          onClick={() =>
            sendDataLayerGlobal({
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              section: 'แท็กที่เกี่ยวข้อง',
              position: !responsive?.isMobile ? 'ใต้:เนื้อหาที่-3' : 'ใต้:ข่าวที่เกี่ยวข้อง',
              data: {
                block: '1',
                title: item,
                heading: 'แท็กที่เกี่ยวข้อง',
                index: index + 1
              }
            })
          }
        >
          {item}
        </a>
      ))}
    </WidgetWrapper>
  );
}

export default WidgetTags;
const WidgetWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  .tags-item {
    display: flex;
    width: fit-content;
    background-color: var(--quaternary-color);
    padding: 5px 10px;
    color: var(--primary-gray);
    font-size: 16pt;
    :hover {
      background-color: #dde5f4;
    }
  }
`;
